class OnThisPageNavigation {
    constructor() {
    }

    init() {
        const nav = jQuery('#on-this-page');
        const links = nav.find('a');

        links.on('click', function () {
            // Clear active state
            links.removeClass('intersecting');

            // Set active state on clicked link
            jQuery(this).addClass('intersecting');
        });
    }
}

export default OnThisPageNavigation;